import React from "react";
import { View, Text } from "react-native";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { If, Then, Else } from "react-if";
import styles from "./styles";

const ExchangeNegotiations = ({ moviments, formatGPXBalance }) => {
  return (
    <View style={styles.containerTrades}>
      <Text style={styles.titleOrdersAndTrade}>
        <FormattedMessage id="token.negociacoes" />
      </Text>
      <View style={styles.contentOrders}>
        <Text style={styles.orderPurchases}>
          <FormattedMessage id="token.negociacoes" />
        </Text>
        <Text style={styles.orderPurchasesBold}>
          <FormattedMessage id="token.realizadas" />
        </Text>
      </View>
      <View style={styles.hr} />
      <View style={styles.contentDescriptionOrders}>
        <Text style={styles.ordersTitle}>
          <FormattedMessage id="token.quantidade" />
        </Text>
        <Text style={styles.ordersTitle}>
          <FormattedMessage id="token.preco" />
        </Text>
      </View>
      <If condition={moviments.length === 0}>
        <Then>
          <Text style={styles.noOrdersMessage}>
            <FormattedMessage id="exchangeNegotiations.txtSemNegociacao" />
          </Text>
        </Then>
        <Else>
          <View style={styles.contentPurchaseOrSale}>
            <View style={{ width: "100%" }}>
              {moviments.map((el, index) => {
                return (
                  <View style={styles.contentPurchaseOrSale} key={index}>
                    <Text style={styles.amountPurchase}>{el.quantity}</Text>
                    <Text style={styles.amountPurchase}>
                      {formatGPXBalance(el.value_coin)}
                    </Text>
                  </View>
                );
              })}
            </View>
          </View>
        </Else>
      </If>
    </View>
  );
};

ExchangeNegotiations.propTypes = {
  moviments: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.number.isRequired,
      value_coin: PropTypes.number.isRequired,
    })
  ).isRequired,
  formatGPXBalance: PropTypes.func.isRequired,
};

export default ExchangeNegotiations;
